import { KanbanBoard } from '../../components/kanban/KanbanBoard';

export function KanbanPage() {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border px-4 py-3">
        <h1 className="text-lg font-semibold">Канбан</h1>
      </div>
      <div className="min-h-0 flex-1">
        <KanbanBoard />
      </div>
    </div>
  );
}
